import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import InputText from '@sharedComponents/InputText';
import Typography from '@sharedComponents/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { isValidLinkUrl } from '../links';

/**
 * Body of the SlateEditor link dialog, rendered through the ModalContext: edits the address of a new
 * or existing link, which must use http, https or mailto.
 */
const LinkModal = ({ initialUrl = '', canRemove = false, onSubmit = () => {}, onRemove = () => {}, onCancel = () => {} }) => {
    const { t } = useTranslation();
    const [url, setUrl] = useState(initialUrl);
    const [invalid, setInvalid] = useState(false);

    const submit = () => {
        if (!isValidLinkUrl(url)) {
            setInvalid(true);
            return;
        }
        onSubmit(url.trim());
    };

    return (
        <FlexBox flexDirection="column" gap="m">
            <InputText
                aria-label={t('Link address')}
                placeholder="https://"
                value={url}
                isError={invalid}
                onChange={(event) => {
                    setUrl(event.target.value);
                    setInvalid(false);
                }}
                onEnter={submit}
            />
            {invalid && (
                <Typography fontSize="s" color="error-primary" role="alert">
                    {t('Enter an address starting with http://, https:// or mailto:')}
                </Typography>
            )}
            <FlexBox justifyContent={canRemove ? 'space-between' : 'flex-end'} gap="s">
                {canRemove && <Button ghost theme="danger" label={t('Remove the link')} action={onRemove} />}
                <FlexBox gap="s">
                    <Button outline label={t('Cancel')} action={onCancel} />
                    <Button label={t('Apply')} action={submit} />
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
};

export default LinkModal;
